import React, { useState } from 'react';
import { Camera, X, ChevronLeft, ChevronRight } from 'lucide-react';
import '../PhotoGallery.css';

// Gallery data with real photos
const galleryCategories = [
  {
    id: 'game-day',
    name: 'Game Day',
    description: 'Action shots from Panthers games',
    photos: [
      { id: 1, url: 'https://customer-assets.emergentagent.com/job_57fc9b05-b88b-4200-a482-c0fddc20ac27/artifacts/whzueoic_DSC05933-Enhanced-NR.jpg', caption: '8U Panthers - Game Day Action' },
      { id: 2, url: 'https://customer-assets.emergentagent.com/job_57fc9b05-b88b-4200-a482-c0fddc20ac27/artifacts/ydrwmyib_DSC06198-Enhanced-NR.jpg', caption: '8U Panthers - On the Field' },
      { id: 3, url: 'https://customer-assets.emergentagent.com/job_57fc9b05-b88b-4200-a482-c0fddc20ac27/artifacts/37ny86p8_DSC06229-Enhanced-NR.jpg', caption: '8U Panthers - Game Action' },
    ]
  },
  {
    id: 'team-photos',
    name: 'Team Photos',
    description: 'Official team and group photos',
    photos: [
      { id: 4, url: 'https://customer-assets.emergentagent.com/job_57fc9b05-b88b-4200-a482-c0fddc20ac27/artifacts/3a5v81f8_1000060724.jpg', caption: '8U Panthers - Team Photo' },
      { id: 5, url: 'https://customer-assets.emergentagent.com/job_57fc9b05-b88b-4200-a482-c0fddc20ac27/artifacts/9c7paelb_DSC06514-Enhanced-NR.jpg', caption: '8U Panthers - Season Highlights' },
      { id: 6, placeholder: true, caption: 'Team photo coming soon' },
    ]
  },
  {
    id: '9u-panthers',
    name: '9U Panthers',
    description: '9U Tackle Football team photos',
    photos: [
      { id: 20, url: '/gallery/9u/IMG_0649.PNG', caption: '9U Panthers - Team Action' },
      { id: 21, url: '/gallery/9u/IMG_0650.PNG', caption: '9U Panthers - On the Field' },
      { id: 22, url: '/gallery/9u/IMG_0651.PNG', caption: '9U Panthers - Game Day' },
      { id: 23, url: '/gallery/9u/IMG_0652.JPG', caption: '9U Panthers - Team Spirit' },
      { id: 24, url: '/gallery/9u/IMG_0653.JPG', caption: '9U Panthers - Action Shot' },
      { id: 25, url: '/gallery/9u/IMG_0654.JPG', caption: '9U Panthers - Game Highlights' },
      { id: 26, url: '/gallery/9u/IMG_0655.JPG', caption: '9U Panthers - On Defense' },
      { id: 27, url: '/gallery/9u/IMG_0656.JPG', caption: '9U Panthers - Touchdown!' },
      { id: 28, url: '/gallery/9u/IMG_0657.JPG', caption: '9U Panthers - Team Celebration' },
    ]
  },
  {
    id: 'flag-panthers',
    name: 'Flag Panthers',
    description: 'Flag Football team photos',
    photos: [
      { id: 30, url: 'https://customer-assets.emergentagent.com/job_c1db756d-3e00-42a6-869e-ac51c49851dc/artifacts/hu35kpbd_IMG_7508.jpeg', caption: 'Flag Panthers - Team Huddle' },
      { id: 31, url: 'https://customer-assets.emergentagent.com/job_c1db756d-3e00-42a6-869e-ac51c49851dc/artifacts/l73y50tc_IMG_7507.jpeg', caption: 'Flag Panthers - Sunset Practice' },
      { id: 32, url: 'https://customer-assets.emergentagent.com/job_c1db756d-3e00-42a6-869e-ac51c49851dc/artifacts/sd0s51yr_DSC_9310.JPG.jpeg', caption: 'Flag Panthers - Game Action' },
      { id: 33, url: 'https://customer-assets.emergentagent.com/job_c1db756d-3e00-42a6-869e-ac51c49851dc/artifacts/4z4gqh0e_IMG_5679.heic', caption: 'Flag Panthers - Team Spirit' },
    ]
  },
  {
    id: 'practice',
    name: 'Practice',
    description: 'Training and practice sessions',
    photos: [
      { id: 7, placeholder: true, caption: 'Practice photo coming soon' },
      { id: 8, placeholder: true, caption: 'Practice photo coming soon' },
      { id: 9, placeholder: true, caption: 'Practice photo coming soon' },
    ]
  },
  {
    id: 'cheerleading',
    name: 'Cheerleading',
    description: 'Our amazing cheer squad',
    photos: [
      { id: 10, placeholder: true, caption: 'Cheer photo coming soon' },
      { id: 11, placeholder: true, caption: 'Cheer photo coming soon' },
      { id: 12, placeholder: true, caption: 'Cheer photo coming soon' },
    ]
  },
  {
    id: 'community',
    name: 'Community Events',
    description: 'Panthers in the community',
    photos: [
      { id: 13, placeholder: true, caption: 'Community photo coming soon' },
      { id: 14, placeholder: true, caption: 'Community photo coming soon' },
      { id: 15, placeholder: true, caption: 'Community photo coming soon' },
    ]
  }
];

const PhotoGallery = () => {
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [currentPhoto, setCurrentPhoto] = useState(null);

  const filteredCategories = selectedCategory === 'all' 
    ? galleryCategories 
    : galleryCategories.filter(cat => cat.id === selectedCategory);

  const allPhotos = galleryCategories.flatMap(cat => 
    cat.photos.map(photo => ({ ...photo, category: cat.name }))
  );

  const openLightbox = (photo) => {
    if (!photo.placeholder) {
      setCurrentPhoto(photo);
      setLightboxOpen(true);
    }
  };

  const closeLightbox = () => {
    setLightboxOpen(false);
    setCurrentPhoto(null);
  };

  const navigatePhoto = (direction) => {
    const currentIndex = allPhotos.findIndex(p => p.id === currentPhoto.id);
    let newIndex = currentIndex + direction;
    
    if (newIndex < 0) newIndex = allPhotos.length - 1;
    if (newIndex >= allPhotos.length) newIndex = 0;
    
    // Skip placeholders
    while (allPhotos[newIndex].placeholder) {
      newIndex += direction;
      if (newIndex < 0) newIndex = allPhotos.length - 1;
      if (newIndex >= allPhotos.length) newIndex = 0;
      if (newIndex === currentIndex) break; // Prevent infinite loop
    }
    
    setCurrentPhoto(allPhotos[newIndex]);
  };

  return (
    <div className="photo-gallery" data-testid="photo-gallery">
      {/* Category Filter */}
      <div className="gallery-filters">
        <button 
          className={`filter-btn ${selectedCategory === 'all' ? 'active' : ''}`}
          onClick={() => setSelectedCategory('all')}
        >
          All Photos
        </button>
        {galleryCategories.map(cat => (
          <button 
            key={cat.id}
            className={`filter-btn ${selectedCategory === cat.id ? 'active' : ''}`}
            onClick={() => setSelectedCategory(cat.id)}
          >
            {cat.name}
          </button>
        ))}
      </div>

      {/* Gallery Grid */}
      {filteredCategories.map(category => (
        <div key={category.id} className="gallery-category">
          <div className="category-header">
            <h3 className="category-title">{category.name}</h3>
            <p className="category-description">{category.description}</p>
          </div>
          
          <div className="photos-grid">
            {category.photos.map(photo => (
              <div 
                key={photo.id} 
                className={`photo-card ${photo.placeholder ? 'placeholder' : ''}`}
                onClick={() => openLightbox(photo)}
                data-testid={`photo-${photo.id}`}
              >
                {photo.placeholder ? (
                  <div className="placeholder-content">
                    <Camera size={48} />
                    <span>Photo Coming Soon</span>
                  </div>
                ) : (
                  <>
                    <img src={photo.url} alt={photo.caption} />
                    <div className="photo-overlay">
                      <span className="photo-caption">{photo.caption}</span>
                    </div>
                  </>
                )}
              </div>
            ))}
          </div>
        </div>
      ))}

      {/* Coming Soon Message */}
      <div className="gallery-coming-soon">
        <Camera size={32} />
        <h4>More Photos Coming Soon!</h4>
        <p>We're building our photo gallery. Check back soon for game day action shots, team photos, and more!</p>
      </div>

      {/* Lightbox */}
      {lightboxOpen && currentPhoto && !currentPhoto.placeholder && (
        <div className="lightbox-overlay" onClick={closeLightbox}>
          <div className="lightbox-content" onClick={e => e.stopPropagation()}>
            <button className="lightbox-close" onClick={closeLightbox}>
              <X size={24} />
            </button>
            <button className="lightbox-nav prev" onClick={() => navigatePhoto(-1)}>
              <ChevronLeft size={32} />
            </button>
            <img src={currentPhoto.url} alt={currentPhoto.caption} />
            <button className="lightbox-nav next" onClick={() => navigatePhoto(1)}>
              <ChevronRight size={32} />
            </button>
            <div className="lightbox-caption">
              <span className="caption-category">{currentPhoto.category}</span>
              <span className="caption-text">{currentPhoto.caption}</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PhotoGallery;
